import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { messages } from '../../../../../../messages';
import Text from '../../../elements/text';
import Block from '../../block';
export const RelatedUrlsBlockErroredView = ({
  testId,
  ...blockProps
}) => /*#__PURE__*/React.createElement(Block, _extends({}, blockProps, {
  testId: testId
}), /*#__PURE__*/React.createElement(Text, {
  message: {
    descriptor: messages.generic_error_message
  }
}));